/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Progress_LabelInputs */

const en_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import in progress`)
};

const fr_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importation en cours`)
};

const de_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import läuft`)
};

const it_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione in corso`)
};

const ru_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт в процессе`)
};

const es_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importación en curso`)
};

const zh_cn2_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入进行中`)
};

const ja_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポート中`)
};

const hi_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात जारी है`)
};

const pt_pt2_load_project_file_progress_label = /** @type {(inputs: Load_Project_File_Progress_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importação em andamento`)
};

/**
* | output |
* | --- |
* | "Import in progress" |
*
* @param {Load_Project_File_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_progress_label = /** @type {((inputs?: Load_Project_File_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_progress_label(inputs)
	if (locale === "de") return de_load_project_file_progress_label(inputs)
	if (locale === "it") return it_load_project_file_progress_label(inputs)
	if (locale === "ru") return ru_load_project_file_progress_label(inputs)
	if (locale === "es") return es_load_project_file_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_progress_label(inputs)
	if (locale === "ja") return ja_load_project_file_progress_label(inputs)
	if (locale === "hi") return hi_load_project_file_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_progress_label(inputs)
	return en_load_project_file_progress_label(inputs)
});